// Borrador del carrito por mesa (productos añadidos y aún no guardados ni
// comandados). Antes solo se guardaba al SALIR de la mesa y no se
// persistía: al recargar la pantalla dentro de la mesa se perdían.
//
// Este middleware guarda el borrador de la mesa activa tras cada cambio
// hecho por el usuario en el carrito (persistido vía redux-persist en
// `product.checkoutHistory`). Solo reacciona a acciones de edición del
// usuario — nunca a resets ni a cargas desde el servidor, para no
// sobrescribir un borrador con un carrito vacío.

import { saveHistoryCheckout } from "src/redux/slices/product";

export const DRAFT_ACTIONS = new Set([
  "product/addCart",
  "product/addEditCart",
  "product/replaceMenuLines",
  "product/deleteCart",
  "product/increaseQuantity",
  "product/decreaseQuantity",
  "product/decreaseQuantityDelete",
  "product/moveProductsToComensal",
  "product/applyDiscount",
  "product/applyLoyaltyRewardToCartLine",
  "product/removeLoyaltyRewardFromCartLine",
  // Tras comandar las líneas pasan a `old`: el guardado elimina el borrador.
  "product/addOldCartAndClean",
]);

// Mesa activa: la seleccionada en el TPV o la marcada como activa.
export function activeMesaId(state) {
  const fromMesas = state?.mesas?.mesa?.id;
  if (fromMesas) return fromMesas;
  const fromActive = state?.active?.activeMesa;
  return fromActive || null;
}

export const cartDraftMiddleware = (storeAPI) => (next) => (action) => {
  const result = next(action);
  if (action && DRAFT_ACTIONS.has(action.type)) {
    const idMesa = activeMesaId(storeAPI.getState());
    if (idMesa) storeAPI.dispatch(saveHistoryCheckout(idMesa));
  }
  return result;
};

export default cartDraftMiddleware;
